import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import Geocoder from '@/utilities/plugin/geocoder'
import Virtualearth from '@/utilities/plugin/virtualearth'
import StreetView from '@/utilities/plugin/streetview'
import GoogleImages from '@/utilities/plugin/googleImages'

const GOOGLE_MAPS_API_KEY = 'AIzaSyCSeyFFsgpiuDTGP3PW62Wb5vm4GAeL-DE'
const VIRTUAL_EARTH_API_KEY = 'AljuGYzPZ9yPhV2pSEmXC1ikoD1gsrHBxesrTzKvPJrFqD63s5CZQlBOt6PbV7Af'

Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_MAPS_API_KEY,
    libraries: 'places,drawing,visualization', // This is required if you use the Autocomplete plugin
  },
})

Vue.use(Geocoder, {
  defaultCountryCode: null, // e.g. 'CA'
  defaultLanguage: null, // e.g. 'en'
  defaultMode: 'lat-lng', // 'address' or 'lat-lng'
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
})

Vue.use(Virtualearth, {
  virtualearthApiKey: VIRTUAL_EARTH_API_KEY,
})

Vue.use(StreetView, {
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
})

Vue.use(GoogleImages, {
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
})
